module.exports = __webpack_public_path__ + "img/question-mark.863d2f3d.svg";